import { render } from "./ActivitiesListingMassAssign.vue?vue&type=template&id=2a16ba2c"
import script from "./ActivitiesListingMassAssign.vue?vue&type=script&lang=js"
export * from "./ActivitiesListingMassAssign.vue?vue&type=script&lang=js"

import "./ActivitiesListingMassAssign.vue?vue&type=style&index=0&id=2a16ba2c&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__